import React from "react";
import { Navigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import Loading from "../common/Loading";
import PropTypes from "prop-types";

export default function PrivateRoute( { children } ) {
    const { isAuthenticated, isLoading } = useAuth0();

    if (isLoading) {
        return <Loading />
    }

    //The children here is our component we would use if we're logged in.
    return (
        isAuthenticated ? children : <Navigate to="/login" />
    )
}

PrivateRoute.propTypes = {
    children: PropTypes.oneOfType([PropTypes.object])
}